// fire.ts — the "testing should be EASY" engine. Fires a random valid word through the real submit
// path (so tiles render and the whole juice stack runs), on demand or on a continuous loop.
//
// Every tuner action (double, halve, randomize, edit) calls fireOnce() so you FEEL the change
// immediately without retyping. The loop keeps words coming every ~1.2s while you drag sliders.

import { randomFireWord, randomPersonalityWord } from "../core/dictionary";

type Submit = (word: string) => void;

let submitFn: Submit = () => {};
let loopTimer: number | null = null;
let loopMs = 1200;
let livelyWords = true; // default ON: draw long, epic-pair-rich words so the reel actually shows up
let lastWord = "";

/** Lively words: draw LONG epic-pair-rich words (so the rare flirt/troll reel is common) instead of
 *  plain 5–10s. On by default; turn off for ordinary vocabulary. (Was "personality test mode".) */
export function setLivelyWords(on: boolean): void {
  livelyWords = on;
}

/** Wire the real submit path (from the Compliance Window) into the fire engine. */
export function setSubmit(fn: Submit): void {
  submitFn = fn;
}

/** Fire one NEW random word — a long epic-pair-rich word when lively words is on, else a plain 5–10. */
export function fireOnce(): void {
  lastWord = livelyWords ? randomPersonalityWord() : randomFireWord();
  submitFn(lastWord);
}

/** Replay the most recent fired word (watch the same reactions again). */
export function replayLast(): void {
  if (lastWord) submitFn(lastWord);
  else fireOnce();
}

/** Fire a long epic-pair-rich word regardless of test flag — the left showcase buttons use this. */
export function fireShowcaseWord(): void {
  lastWord = randomPersonalityWord();
  submitFn(lastWord);
}

export function isLooping(): boolean {
  return loopTimer !== null;
}

/** Start/stop the continuous auto-fire loop. Returns the new state. */
export function toggleLoop(onTick?: () => void): boolean {
  if (loopTimer !== null) {
    clearInterval(loopTimer);
    loopTimer = null;
    return false;
  }
  fireOnce();
  onTick?.();
  loopTimer = window.setInterval(() => {
    fireOnce();
    onTick?.();
  }, loopMs);
  return true;
}

export function setLoopInterval(ms: number): void {
  loopMs = ms;
  if (loopTimer !== null) {
    clearInterval(loopTimer);
    loopTimer = window.setInterval(fireOnce, loopMs);
  }
}
